module.exports = __webpack_public_path__ + "img/tinymce-small.a2a1f73.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/tinymce/skins/lightgray/fonts/tinymce-small.svg
// module id = 1101
// module chunks = 0